export const containerStyles = {
  marginTop: '32px',
  display: 'flex',
  '& > div:not(:last-child)': {
    marginRight: '8px',
  },
  justifyContent: ['center', 'center', 'start'],
}

export const getListItemImageStyles = (isActive: boolean) => ({
  ...(isActive
    ? {
        filter: 'grayscale(0)',
        opacity: '1',
        transition: 'filter, opacity, 200ms',
      }
    : {
        filter: 'grayscale(1)',
        opacity: '0.5',
        transition: 'filter, opacity, 200ms',
      }),
})

export const getFontStyles = (isActive: boolean) => ({
  textShadow: isActive ? '0px 0px 1px black' : '0',
  fontWeight: 400,
  transition: 'textShadow, 200ms',
})
